// @flow

import React, { Component } from "react";
import classNames from "classnames";

import { ComboBox } from "@components";
import type { OptionType } from "@components";
import type { WidgetProps } from "@rjsf/utils";
type Props = $Exact<{
  ...WidgetProps,
  options: Object,
}>;

export class SelectWidgetSchemaTable extends Component<Props> {
  handleChange = (val: OptionType): void => {
    this.props.onChange(val || val === false ? val : undefined);
  };

  render() {
    const props = Object.assign({}, this.props, {
      disabled: this.props.disabled,
      readOnly: this.props.readonly,
      autoFocus: this.props.autofocus,
      onChange: this.handleChange,
      options: this.props.options.enumOptions,
      value: this.props.value,
      withoutPortal: this?.props?.schema?.withoutPortal,
    });

    delete props.formContext;
    delete props.autofocus;
    delete props.rawErrors;
    delete props.registry;
    delete props.schema;
    if (!props.readonly || props.placeholder?.length < 2) delete props.placeholder;

    const shouldHighlightRequired =
      this.props.required &&
      (!this.props.value || this.props.value < 0) &&
      (!this.props.rawErrors || !this.props.rawErrors.length);
    return (
      <div
        className={classNames("schema-form-widget-select flex-1", {
          "no-pointer-events": props.isDisabled,
          "form-input--required": shouldHighlightRequired,
        })}
      >
        <ComboBox
          options={props.oneOf.map(option => {
            return { label: option.title, value: option.const };
          })}
          value={this.props.data}
          onChange={this.handleChange}
          disabled={this.props.disabled}
          readOnly={!this.props.active}
          placeholder={this.props.placeholder}
          isMulti={this.props.isMulti}
          className={this.props.className}
        />
      </div>
    );
  }
}

export default SelectWidgetSchemaTable;
